// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"8bff4de5","71":"18f18afc"}[chunkId] + ".chunk.js";
};